import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


// 재사용 모듈
const dialogModule = {
  namespaced: true,
  state() {
    return { opened: false }
  },
  mutations: {
    opened(state, payload) {
      state.opened = payload.opened;
    }
  },
  actions: {
    openModal ({ dispatch, commit, getters, rootGetters }, payload) {
      payload.opened = true;
      commit('opened', payload)
      commit('pushModal', payload, {root: true});
    },
    closeModal ({ dispatch, commit, getters, rootGetters }, payload) {
      payload.opened = false;
      commit('opened', payload)
      commit('popModal', payload, {root: true});
    }
  }
}

export const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    explanation: dialogModule,
    explanationForm: dialogModule,
    memoForm: dialogModule,
    settings: dialogModule,
    chartAnalysis: dialogModule,
    questionsAnalysis: dialogModule,
    report: dialogModule,
    help: dialogModule,
    omr: dialogModule,
    testPaper: dialogModule
  },
  state: {
    openedModals: [] as Array<object>,
    isOmrLearn: false
  },
  mutations: {
    pushModal(state, payload) {
      state.openedModals.push(payload);
    },
    popModal(state, payload) {
      state.openedModals.pop();
    },
    popLastModal(state, payload) {
      if(!state.openedModals.length) {
        return;
      }

      const lastName = state.openedModals[state.openedModals.length-1]['name'];
      state[`${lastName}`].opened = false;
      state.openedModals.pop();
    },
    initModals(state, payload) {
      state.openedModals = [];
    },
    changeOmrLearn(state, payload) {
      state.isOmrLearn = payload;
    }
  },
  actions: {
    popLastModal({ dispatch, commit }, payload) {
      commit(`popLastModal`)
    },
    changeOmrLearn({ dispatch, commit }, payload) {
      commit(`changeOmrLearn`, payload);
    }
  }
});